import React from "react";
import { useAuth } from "@/context/AuthContext";
import { BentoHome } from "./bento/BentoHome";
import { MyDayPage } from "./myday/MyDayPage";

/** Reps land on their work queue (My Day); Sales Heads and Super Admins on the team overview */
export function DashboardPage() {
  const { user } = useAuth();
  const role = String(user?.UserRole?.RoleCode || "").toUpperCase();
  return role === "SALES_EXEC" ? <MyDayPage /> : <BentoHome />;
}
